<div *ngFor="let categoria of categorias">

  <div class="card-header">
    <mat-card-title class="name-title">{{categoria.nombreCategoria}}</mat-card-title>
  </div>

  <div class="card-content" >

    <div class="box-child-card">

      <div *ngFor="let sistema of categoria.listaSistema">

        <div class="content" (click)="onSelectedCategoriaSistema(categoria.codigoCategoria, sistema.codigoSistema)">
          
            <div class="icon-content"> 
                           
                <div class="icon-img">
                  <img src="assets/svg/vector.svg" alt="*">                  
                </div>                
                  
              <div class="nombre-sistema">{{sistema.nombreSistema}}</div>
            </div>          

        </div>

      </div>
    </div>
  </div>
</div> 